import { render, staticRenderFns } from "./TwoKnife.vue?vue&type=template&id=71484031&scoped=true"
import script from "./TwoKnife.vue?vue&type=script&lang=js"
export * from "./TwoKnife.vue?vue&type=script&lang=js"
import style0 from "./TwoKnife.vue?vue&type=style&index=0&id=71484031&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "71484031",
  null
  
)

export default component.exports